import { render } from "./Page12.vue?vue&type=template&id=2f33daf6"
import script from "./Page12.vue?vue&type=script&lang=js"
export * from "./Page12.vue?vue&type=script&lang=js"

import "./Page12.vue?vue&type=style&index=0&id=2f33daf6&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__